import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from "ng-select";
import { BsDatepickerModule, ModalModule, TooltipModule } from 'ngx-bootstrap';
import { BoxRetalStampsModule } from '../../share/boxRetalStamps/boxRetalStamps.module';
import { HistoryBoxModule } from '../../history-box/history-box.module';
import { Select2ApiModule } from '../../share/select2Api/select2Api.module';
import { BoxRetalStampsTHModule } from '../../share/boxRetalStampsTH/boxRetalStampsTH.module';
import { LinkLoyaltyComponent } from './linkLoyalty.component';
import { RouterModule } from '@angular/router';
import { FilterProductsModule } from '../../../../../layout/filter-products/filter-products.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    BsDatepickerModule.forRoot(),
    TooltipModule,
    BoxRetalStampsModule,
    HistoryBoxModule,
    Select2ApiModule,
    ModalModule,
    BoxRetalStampsTHModule,
    RouterModule,
    FilterProductsModule,
    TranslateModule
  ],
  declarations: [LinkLoyaltyComponent]
})
export class LinkLoyaltyModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/batchstamp/linkLoyalty/linkLoyalty.modules.ts